module.exports = __webpack_public_path__ + "img/assuraf_white.656d90df.png";